import { API_BASE_URL } from './api';

class ApiError extends Error {
  status?: number;

  constructor(message: string, status?: number) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
  }
}

// Helper to handle fetch responses
async function handleResponse(response: Response) {
  const contentType = response.headers.get('content-type');
  const data = contentType && contentType.includes('application/json')
    ? await response.json()
    : await response.text();

  if (!response.ok) {
    throw new ApiError(
      (data && (data.message || data.error)) || 'Request failed',
      response.status
    );
  }

  return data;
}

// -------------------- GET all FAQs --------------------
export const getFAQs = async () => {
  try {
    console.log(`🔍 Fetching FAQs from: ${API_BASE_URL}/faqs`);
    const response = await fetch(`${API_BASE_URL}/faqs`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    const data = await handleResponse(response);
    console.log('✅ FAQ API response:', data);
    return data;
  } catch (error: any) {
    console.error('❌ FAQ API error:', error);
    if (error instanceof ApiError) throw error;
    throw new Error('Network error while fetching FAQs');
  }
};

// -------------------- GET single FAQ --------------------
export const getFAQ = async (id: string) => {
  try {
    const response = await fetch(`${API_BASE_URL}/faqs/${id}`);
    return await handleResponse(response);
  } catch (error: any) {
    if (error instanceof ApiError) throw error;
    throw new Error(`Network error while fetching FAQ ${id}`);
  }
};

// -------------------- CREATE FAQ --------------------
export const createFAQ = async (faqData: {
  faq_question: string;
  faq_answer: string;
  faq_status?: string;
}) => {
  try {
    const response = await fetch(`${API_BASE_URL}/faqs`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(faqData),
    });
    return await handleResponse(response);
  } catch (error: any) {
    if (error instanceof ApiError) throw error;
    throw new Error('Network error while creating FAQ');
  }
};

// -------------------- UPDATE FAQ --------------------
export const updateFAQ = async (
  id: string,
  faqData: {
    faq_question: string;
    faq_answer: string;
    faq_status: string;
  }
) => {
  try {
    const response = await fetch(`${API_BASE_URL}/faqs/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(faqData),
    });
    return await handleResponse(response);
  } catch (error: any) {
    if (error instanceof ApiError) throw error;
    throw new Error(`Network error while updating FAQ ${id}`);
  }
};

// -------------------- DELETE FAQ --------------------
export const deleteFAQ = async (id: string) => {
  try {
    const response = await fetch(`${API_BASE_URL}/faqs/${id}`, {
      method: 'DELETE',
    });
    return await handleResponse(response);
  } catch (error: any) {
    if (error instanceof ApiError) throw error;
    throw new Error(`Network error while deleting FAQ ${id}`);
  }
};
